import React, { Component, ChangeEvent, ReactNode, FormEvent } from 'react';
import Alert from 'react-bootstrap/Alert';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Spinner from 'react-bootstrap/Spinner';
import { AuthHelper } from '../../helpers/AuthHelper';

enum PasswordForgottenRequestState {
  NOT_SENT,
  PENDING,
  DONE,
  FAILED,
}

interface PasswordForgottenFormState {
  username: string;
  usernameError?: string;
  requestState: PasswordForgottenRequestState;
}

export class PasswordForgottenForm extends Component<any, PasswordForgottenFormState> {
  private static readonly INPUT_USERNAME = 'username';

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  constructor(props: any) {
    super(props);
    this.state = {
      username: '',
      requestState: PasswordForgottenRequestState.NOT_SENT,
    };
  }

  handleInputChange = (event: ChangeEvent): void => {
    const { name, value } = (event.target as HTMLInputElement);
    switch (name) {
      case PasswordForgottenForm.INPUT_USERNAME:
        this.setState({ username: value });
        break;
    }
  };

  resetErrors = (): void => {
    this.setState({
      usernameError: undefined
    });
  };

  validate = (username: string): boolean => {
    if (!username || username.length === 0) {
      this.setState({
        usernameError: 'Vul je e-mailadres in'
      });
      return false;
    }
    return true;
  };

  handleSubmit = (event: FormEvent): void => {
    event.preventDefault();
    this.resetErrors();

    const { username } = this.state;
    const isValid = this.validate(username);
    if (!isValid) {
      return;
    }

    this.setState({
      requestState: PasswordForgottenRequestState.PENDING
    }, () => {
      AuthHelper.requestPasswordForgot(username)
        .then(() => {
          this.setState({
            requestState: PasswordForgottenRequestState.DONE,
          });
        })
        .catch(() => {
          this.setState({
            requestState: PasswordForgottenRequestState.FAILED,
          });
        });
    });
  };

  render(): ReactNode {
    const { usernameError, requestState } = this.state;
    return (
      <>
        <Form className="form mb-3" onSubmit={this.handleSubmit}>
          <Form.Group className="form__item">
            <Form.Label>Gebruikersnaam</Form.Label>
            <Form.Control
              name={PasswordForgottenForm.INPUT_USERNAME}
              type="text"
              autoComplete="username"
              onChange={this.handleInputChange}
              isInvalid={!!usernameError}
            />
            {usernameError && <Alert variant="danger">{usernameError}</Alert> }
          </Form.Group>
          <Button
            className="form__submit"
            variant="primary" type="submit">{
              requestState === PasswordForgottenRequestState.PENDING ?
                <Spinner animation="border" role="status"/> :
                'Tijdelijk wachtwoord aanvragen'
            }</Button>
        </Form>
        {
          requestState === PasswordForgottenRequestState.DONE &&
          <Alert variant="info">Er is een herstellink naar het e-mailadres gestuurd</Alert>
        }
        {
          requestState === PasswordForgottenRequestState.FAILED &&
          <Alert variant="danger">Wachtwoord herstellen niet mogelijk voor dit e-mailadres</Alert>
        }
      </>
    );
  }
}
